import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ChatService } from '../..';
import { Session } from '../../services/session.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

declare function doLiveChat(): any;
declare function HandleChatPopup(): any;

@Component({
    selector: 'app-technical-difficulties',
    template: `
    <div class="page-container tw-w-full">
      <div class="alert alert-danger technical-diff">
        {{ 'We are currently experiencing technical difficulties.' | translation: translationRequest }}
        <br /><br />
        {{ 'We apologize for any inconvenience.' | translation: translationRequest }}
        <br /><br />
        {{ 'You can go back to the' | translation: translationRequest }}
        <a tabindex="0" (click)="logOut()" class="spanLink">
          {{ 'login page' | translation: translationRequest }}
        </a>
        {{ ' ' }}{{ 'and try again.' | translation: translationRequest }} <br /><br />
        {{ 'Please feel free to call us at the following numbers and times:' | translation: translationRequest }}
        <br /><br />
        {{ 'Live Chat help is available from 8:00 a.m. until 5:00 p.m., Central Time, Monday through Friday.' | translation: translationRequest }}
        <br /><br />
        {{ 'Sedgwick Technical Support is available from 7:00 a.m. to 6:00 p.m., Central Time, Monday through Friday.' | translation: translationRequest }}
        <br /><br />
        {{ 'Toll-free number: (866) 647-7610' | translation: translationRequest }}
        <br /><br />
        {{ 'Toll number: (901) 415-7800' | translation: translationRequest }}
    
        @if (hasSessionId) {
          <div>
            <span>
              <br />
              {{ 'Please have the following information available.' | translation: translationRequest }}
              <br /><br />
              <span>
                {{ 'Session ID:' | translation: translationRequest }} <span>{{ sessionId }} </span>
                <br />
                <span>
                  {{ currentDate }}
                </span>
              </span>
            </span>
          </div>
        }
      </div>
      <span style="display:block;">
        <app-button
          mat-button
          [attr.aria-label]="'Live chat' | translation: translationRequest"
          tabindex="0"
          mat-raised-button
          emphasis="High"
          [icon]="'chat_bubble'"
          (click)="showLiveChat()"
          id="openLiveChatBtn"
          label="LIVE CHAT"
          >
        </app-button>
        <span
          id="displayLocation"
          style="line-height:25px;display:block;width: inherit;"
        ></span>
      </span>
    </div>
    `,
    styles: [
        `
      .technical-diff {
        width: max-content;
        padding: 20px;
      }
      .page-container {
        margin: 20px;
      }
      @media (max-width: 480px) {
        .page-container {
          margin: 0px;
        }
      }
    `,
    ],
    providers: [DatePipe],
    standalone: false
})
export class TechnicalDifficultiesComponent implements OnInit {
  hasSessionId: boolean;
  sessionId: string;
  currentDate: string = new Date().toString();
  window: any;
  lhnHocButton: any;
  displayLocation: any;
  passVar: any;

  translationRequest = new TranslationRequest({
      language: sessionStorage.getItem('languagepreference'),
      key: null,
      contNum: 0,
      tableName: null,
      primaryKey: null,
      primaryValue: null,
      lob: null,
      group: 'Shared',
      subGroup: 'Shared',
    });
    
  constructor(
    private datePipe: DatePipe,
    public session: Session,
    private chat: ChatService
  ) {
    this.currentDate = this.datePipe.transform(
      this.currentDate,
      'M/d/yyyy, h:mm:ss a'
    );
  }

  ngOnInit(): void {
    this.sessionId = this.session.user.sessionId;
    if (this.sessionId != undefined) {
      this.hasSessionId = true;
    }

    this.passVar = {
      Flag: '',
      top: '',
      left: window.innerWidth,
    };

    doLiveChat(); //Initialize Live Chat; config is pulled from the API inside doLiveChat
    this.chat.close();
  }

  logOut() {
    this.session.logoff();
  }

  showLiveChat() {
    HandleChatPopup();
  }
}
